var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicatelarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.37 4.57A4.65 4.65 0 0 0 14.76 0H4.63A4.61 4.61 0 0 0 0 4.66v10.11a4.66 4.66 0 0 0 4.57 4.66A4.65 4.65 0 0 0 9.18 24h10.2A4.62 4.62 0 0 0 24 19.36V9.23a4.67 4.67 0 0 0-4.63-4.66ZM4.57 9.23v8.32a2.76 2.76 0 0 1-2.72-2.78V4.66a2.8 2.8 0 0 1 2.78-2.79H14.7a2.77 2.77 0 0 1 2.76 2.7H9.23a4.63 4.63 0 0 0-4.66 4.66Zm17.52 10.11a2.8 2.8 0 0 1-2.72 2.79H9.23a2.77 2.77 0 0 1-2.78-2.79V9.23a2.8 2.8 0 0 1 2.78-2.79h10.14a2.77 2.77 0 0 1 2.72 2.79v10.11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.77 13.36H15.2V10.9a.93.93 0 0 0-.92-.93.92.92 0 0 0-.93.93v2.47h-2.61a.92.92 0 0 0-.93.93.93.93 0 0 0 .93.93h2.59v2.48a.93.93 0 0 0 .92.93.92.92 0 0 0 .93-.93v-2.48h2.59a.92.92 0 0 0 .92-.93.93.93 0 0 0-.92-.93Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicatelarge);
export default __webpack_public_path__ + "static/media/duplicate.large.e494b93f445761576c850377be9c59a4.svg";
export { ForwardRef as ReactComponent };